const DataHeroSection = () => {
  return {
    heroSection: {
      top: {
        title: "The easiest way to turn your ideas into lovely sketches!",
        description:
          "Sketchize is built for UI/UX Designers to help them design lovely apps for mobile, tablet, and desktop devices. Just choose any of the sketch sheets that fit your project, print it out, and start to sketch your dream!",
      },
      bottom: {
        title: "Your ideas are worth sketching. Don’t you think?",
        description:
          "So, why not to sketch them down by using Sketchize’s free sketch sheets that built exactly for people like you! Just choose any of the sketch sheets that fits your project, print them out and start to sketch your design ideas.",
      },
    },
  };
}

const DataSmartphone = () => {
  return {
    smartphone: {
      title: "WHAT'S INCLUDED?",
      description: "The smartphone sketch sheets will make it super easy for you to think and design user-centered mobile apps. Just download any of the device sketch sheets and start to sketch quickly.",
      categoryName: "SMARTPHONE",
      categoryDescription: "The smartphone sketch sheets will make it super easy for you to think and design user-centered mobile apps. Just download any of the device sketch sheets and start to sketch quickly.",
      up2: {
        blank: {
          title: "2-UP BLANK",
          description: "2-UP smartphone sketch sheet without dotted grid."
        },
        expanded: {
          title: "2-UP EXPANDED",
          description: "2-UP smartphone sketch sheet with dotted grid and extended screen flow."
        },
        dotted: {
          title: "2-UP WITH GRID",
          description: "2-UP smartphone sketch sheet with dotted grid."
        }
      },
      up3: {
        blank: {
          title: "3-UP BLANK",
          description: "3-UP smartphone sketch sheet without dotted grid."
        },
        dotted: {
          title: "3-UP WITH GRID",
          description: "3-UP smartphone sketch sheet with dotted grid."
        }
      }
    }
  }
}

const DataTablet = () => {
  return {
    tablet: {
      title: "WHAT'S INCLUDED?",
      description: 'This package contains a single and a 2-UP tablet sketch sheets with and without dotted grid. With tablet sketch sheets you can quickly create beautiful design ideas for tablet devices.',
      categoryName: "TABLET",
      categoryDescription: "Tablet sketch sheets will allow you to sketch lovely apps for tablet devices and help you to take faster notes during time of project meetings.",
      single: {
        blank: {
          title: "SINGLE BLANK",
          description: "Single tablet sketch sheet without dotted grid."
        },
        dotted: {
          title: "SINGLE WITH GRID",
          description: "Single tablet sketch sheet with dotted grid."
        }
      },
      up2: {
        blank: {
          title: "2-UP BLANK",
          description: "2-UP tablet sketch sheet without dotted grid."
        },
        dotted: {
          title: "2-UP WITH GRID ",
          description: "2-UP tablet sketch sheet with dotted grid"
        }
      }
    }
  }
}

const DataBrowser = () => {
  return {
    browser: {
      title: "WHAT'S INCLUDED?",
      description: "This package contains a single browser sketch sheet with and without dotted grid versions. With the desktop browser wireframing sheets you can start to sketch out your layout design ideas for desktop devices.",
      categoryName: "BROWSER",
      categoryDescription: "Web browser sketch sheets will allow you to sketch out marvelous web apps and help you to design the page flows and layouts of an entire web site."
    }
  }
}

const DataSketchpad = () => {
  return {
    sketchpad: {
      title: "Free Sketchpads",
      description: "...",
      categoryName: "SKETCHPAD",
      categoryDescription: "..."
    }
  }
}


export { DataHeroSection, DataSmartphone, DataTablet, DataBrowser, DataSketchpad }



// WEBPACK FOOTER //
// ./src/components/Data/Data.js